import React, {useState} from 'react';
import {useParams} from "react-router-dom";
import MenuCategoryItemsModal from "../../components/Category/MenuCategoryItemsModal";
import PromotionHelper from "../../../../services/Menu/services/Promotion/PromotionHelper";
import AvailableHelper from "../../../../services/Menu/services/Availability/AvailableHelper";
import {RootState} from "../../../../../reducers";
import {
    getAvailabilities,
    getCategories,
    getItemGroups,
    getItems,
    getMenus,
    getPromotions
} from "../../../../services/Menu/reducer";
import {getSession, selectLocale} from "../../../../services/Session/reducer";
import {getStoreConfig} from "../../../../services/Store/reducer";
import {getCart} from "../../../../services/Cart/reducer";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import CategoryHelper from "../../../../services/Menu/services/Category/CategoryHelper";

type Props = ReturnType<typeof mapStateToProps>;

const MenuCategoryPage = ({
                              promotions,
                              cart,
                              items,
                              categories,
                              availabilities,
                              session,
                              itemGroups,
                              menus,
                              config,
                              locale
                          }: Props) => {
    const {id} = useParams<{ id?: string }>();
    const [showModal, setShowModal] = useState(true);
    let categoryMenus: any[] = [];

    const getParsedCategory = () => {
        const availablePromotions = PromotionHelper.getActivePromotionsForCategory(promotions, cart.total);
        const categoryById = categories.find((category: any) => category.status === 'ENABLED' && Number(id) === category.id);
        const parsedCategory = CategoryHelper.getParsedCategories([categoryById], items, availabilities, availablePromotions, session, cart, itemGroups, menus)[0];

        if (parsedCategory.entities.length === 0) return undefined;

        const menusWithCategory = CategoryHelper.getMenusForCategory(menus, parsedCategory);
        const menuAvailabilities = AvailableHelper.getAvailabilities(availabilities, menusWithCategory.map((menu: any) => menu.availability_id));
        categoryMenus = [...menusWithCategory];
        return menuAvailabilities.length > 0 ? parsedCategory : undefined;
    }

    const category = getParsedCategory();

    if (!category) return <></>;

    return (
        <MenuCategoryItemsModal show={showModal} category={category} setShowModal={setShowModal} config={config}
                                availabilities={availabilities} locale={locale} menus={categoryMenus}
                                session={session} promotions={promotions}/>
    )
}

const mapStateToProps = (state: RootState) => ({
    availabilities: getAvailabilities(state.menu),
    promotions: getPromotions(state.menu),
    categories: getCategories(state.menu),
    items: getItems(state.menu),
    itemGroups: getItemGroups(state.menu),
    session: getSession(state.session),
    config: getStoreConfig(state.config),
    cart: getCart(state.cart),
    menus: getMenus(state.menu),
    locale: selectLocale(state.session),
})

const connector = connect(mapStateToProps);
export default withTranslation()(connector(MenuCategoryPage));
